import { createAsyncThunk } from '@reduxjs/toolkit'

import { IUserTicketData } from 'meta/pages/v4/ticket'
import { TicketController } from 'controller/ticket'

type Returned = IUserTicketData[]

type Props = {
  ids: string[]
  eventId?: number
}

export const getBulkData = createAsyncThunk<Returned, Props>('pages/ticket/bulk', async (props) => {
  const { ids, eventId } = props

  const data = await TicketController.getBulkData({ ids })

  if (eventId) {
    return data.items.map((x) => {
      return { ...x, eventId: eventId }
    })
  }

  return data.items
})
